import { graphWallFill } from './';
export const graphOverviewFill = (theme, parameters) => {
  const wallFill = graphWallFill(theme, parameters);
  return {
    transparency: 0,
    fillColor: wallFill.fillColor
  };
};
//# sourceMappingURL=graphOverviewFill.js.map